import React from "react";
import ProfileImage from "../../UI/ProfileImage/ProfileImage";
import Button from "../../UI/Button/Button";
import "./WelcomeBack.scss";
import GlobalStore from "../../store/globalStore";
import {
  AGetStageCompletionStatus,
} from "../../Services/registration/continueApiService";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  dashboardUrl,
  containerUrl,
  statusUrl,
} from "../../utils/constants";
import {
  clientPartialDetailsToStore,
  updateUtmInfo,
  setStageData,
  ageCalculator,
} from "../../Services/globalService";
import { APendingUploadList } from "../../Services/dashboard/eSignApiServices";
import welcomeBack from "../../../assets/icons/welcomeBack.jpg";
import { ACheckClientProfilingData } from "../../Services/dashboard/profilerApiServices";
// Single source of truth for navbar / Cache / KRA / getStatus-navigation logic.
import {
  completeModuleStatus,
  checkModuleCompleteness,
  markStepIncomplete,
  resolveCacheThenKra,
  applyKraResponseToStore,
  resolveStatusNavigationUrl,
  completeAllStagesExceptLast,
} from "../../Services/navigationOrchestrator";
import {
  AGetClientDetailsByPan,
} from "../../Services/registration/panDobApiService";
import config from "../../../config/domain";
import { getProfileDetailsFromAadhar } from "../ShareAdd/ShareAdd";
import moment from "moment";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { ITokenObj } from "../../types/genericTypes";

export interface WelcomeBackProps { }

const WelcomeBack: React.FC<WelcomeBackProps> = (props) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [dematAccountFound, setDematAccountFound] = React.useState<any>(null);
  const [clientName, setClientName] = React.useState<string>("");
  const [errCode, setErrCode] = React.useState<number | string>();
  const [addressRejctedFound, setAddressRejctedFound] =
    React.useState<any>(null);
  const [isUploadDocumentsCompleted, setIsUploadDocumentsCompleted] =
    React.useState<boolean>(false);
  // const history = useHistory();
  const navigate = useNavigate()
  let userId = "0";
  // console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
  const tokenObj: string = decryptJwtToken(GlobalStore?.token);
  if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
    let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
    userId = tokenMainObj?.UserId?.toString();
  }

  React.useEffect(() => {
    if (Object.keys(clientPartialDetailsToStore()).length === 0) {
      // history.push(containerUrl.registration);
      navigate(containerUrl.registration)
    } else if (
      GlobalStore.isNormalClient !== undefined &&
      GlobalStore?.isNormalClient !== null &&
      GlobalStore?.isNormalClient &&
      GlobalStore.isPANVerified !== undefined &&
      GlobalStore?.isPANVerified !== null &&
      !GlobalStore.isPANVerified &&
      userId === "0"
    ) {
      console.log(
        "GlobalStore.isNormalClient",
        GlobalStore.isNormalClient,
        "GlobalStore.isPANVerified",
        GlobalStore.isPANVerified
      );
      // history.push(containerUrl.registration);
      navigate(containerUrl.registration)
    } else {
      setIsLoading(true);
      if (
        GlobalStore.clientPrimaryDetailId === "" ||
        GlobalStore.clientPrimaryDetailId === "0" ||
        GlobalStore.clientPrimaryDetailId === null
      ) {
        console.log("Wrong clientPrimaryDetailId");
      }
      let panNo = GlobalStore?.personaldetails?.pan;
      if (panNo == "" || panNo == undefined || panNo == null) {
        const clientPartialDetails_ao1 = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        panNo = clientPartialDetails_ao1.pan;
      }
      AGetClientDetailsByPan(searchByLeadId, panNo);
      window.sessionStorage.setItem("isSeniorCitizen", "false");
      const clientFullName =
        window.sessionStorage.getItem("clientNameNew") ||
        GlobalStore.personaldetails.PANName.toLowerCase()
      setClientName(
        clientFullName?.replace(/(^\w|\s\w)/g, (m: string) => m.toUpperCase()) ||
        ""
      );
      APendingUploadList(checkPendingUpload, GlobalStore.applicationID);
    }
  }, []);

  function searchByLeadId(res: any) {
    if (!res || res.error) {
      // setErrCode("119 - Error in fetching Client details from our system.");
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data && res.data != null) {
        if (
          GlobalStore.personaldetails.pan.toUpperCase().trim() ===
          res.data.PAN.toUpperCase().trim()
        ) {
          GlobalStore.token = res.data.Token;
          GlobalStore.applicationID = res.data.ApplicatoinId;
          // GlobalStore.entityType = res?.data?.entitytype
          // GlobalStore.entitySubType = res?.data?.entitysubtype
          GlobalStore.personaldetails.pan = res.data.PAN;
          GlobalStore.leadId = res.data.LeadId;
          GlobalStore.clientPrimaryDetailId = res.data.ClientPrimaryDetailId;
          const clientPartialDetails_ao = JSON.parse(
            window.localStorage.getItem("clientPartialDetails_ao") || "{}"
          );
          clientPartialDetails_ao.clientPrimaryDetailId =
            GlobalStore.clientPrimaryDetailId;
          window.localStorage.setItem(
            "clientPartialDetails_ao",
            JSON.stringify(clientPartialDetails_ao)
          );
        }
      } else {
        setErrCode(res.error);
        setIsLoading(false);
      }
    }
  }

  function populateSavedData() {
    const panDetails = GlobalStore.personaldetails.panDetails;
    console.log("panDetails", GlobalStore.personaldetails);
    if ((typeof panDetails !== "undefined" && panDetails && panDetails !== "") || GlobalStore.personaldetails.pan) {
      console.log("Line No 97 If call ");
      setIsLoading(true);
      //    updateUtmInfo(updateUtmDetails); // here updating utmcreative and content.

      ACheckClientProfilingData(
        getProfilerStatus,
        GlobalStore.applicationID,
        config.ClientProfilingDataSourseId
      );
    }
  }

  function getProfilerStatus(res: any) {
    if (!res || res.error) {
      // setErrCode("1231- Failed to fetch client profiling data.");
      setErrCode(res.error);
    } else {
      if (res.hasOwnProperty("data")) {
        if (res.data === true) completeModuleStatus(dashboardUrl.profiler);
        AGetStageCompletionStatus(
          getClientStageDetails,
          GlobalStore.applicationID
        );
      } else {
        setErrCode(res.error);
      }
    }
  }

  function updateUtmDetails(res: any) {
    if (!res || res.error) {
      // setErrCode(123);
    }
  }

  function checkPendingUpload(res: any) {
    setIsLoading(true);
    // debugger
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      if (res && res?.data == null) {
        let isUploadDocumentsCompleted: boolean = false;
        AGetStageCompletionStatus(
          (res: any) => getClientStageDetailsNew(res, isUploadDocumentsCompleted, undefined, undefined, true),
          GlobalStore.applicationID
        );
      }
      else if (res && res.data) {
        let resultObj = JSON.parse(res.data);
        let list: Array<any> = resultObj.filter(
          (item: any) =>
            // prev api types
            // item.documentcategoryid !== 36 &&
            // item.documentcategoryid !== 30 &&
            // item.documentcategoryid !== 62
            // item.DocumentCategoryId !== 36 &&
            // item.DocumentCategoryId !== 30 &&
            // item.DocumentCategoryId !== 62
            item.Mandatory == true
        );
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length === 1
        ) {
          let listObjFound = list.find(
            (listObj) =>
              listObj?.DocumentCategory == "DP Document" &&
              listObj?.DocumentCategoryId == 96
          );
          let addressAccountFoundLocal = list.find(
            (listObj) =>
              (listObj?.DocumentCategory == "Address Proof Permanent" &&
                listObj?.DocumentCategoryId == 4) ||
              (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                listObj?.DocumentCategoryId == 3)
          );
          setAddressRejctedFound(addressAccountFoundLocal);
          setDematAccountFound(listObjFound);
          if (listObjFound !== null && listObjFound !== undefined) {
            setIsUploadDocumentsCompleted(true);
          }
        }
        if (
          list !== undefined &&
          list !== null &&
          list?.length > 0 &&
          list?.length > 1
        ) {
          let addressAccountFoundLocal = list.find(
            (listObj) =>
              (listObj?.DocumentCategory == "Address Proof Permanent" &&
                listObj?.DocumentCategoryId == 4) ||
              (listObj?.DocumentCategory == "Address Proof Correspondence" &&
                listObj?.DocumentCategoryId == 3)
          );
          setAddressRejctedFound(addressAccountFoundLocal);
        }

        if (list.length === 0 || list[0].count === 0)
          setIsUploadDocumentsCompleted(true);
      } else {
        setIsUploadDocumentsCompleted(true)
      }
    }
    setIsLoading(false);
  }
  const convertDate = (dateString: string) => {
    // Split the input date string by "/"
    const [day, month, year] = dateString.split("/");

    // Create a new Date object with the parsed values
    const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); // month - 1 because months are zero-indexed

    // Format the date to "mm-dd-yyyy"
    const formattedDate = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${day.padStart(2, "0")}-${year}`;

    return formattedDate;
  };
  /**
   * Cache -> KRA -> fallback cascade for this "profile/personal incomplete"
   * client. Delegates the actual cascade order/rules to the centralized
   * navigationOrchestrator (resolveCacheThenKra); this function only wires
   * up WelcomeBack's specific per-outcome side effects (localStorage shape,
   * navigation target), matching the legacy cacheKRAFunction/CacheFunction/
   * KraCheckApi/kraDobCheckNew behavior exactly.
   */
  const resolveCacheAndKraForClient = (
    onNoCacheNoKraFallback: () => void,
    dob?: any
  ) => {
    resolveCacheThenKra({
      applicationID: GlobalStore.applicationID,
      dob,
      pan: GlobalStore.personaldetails.pan,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId,
      leadId: GlobalStore.leadId,
      createdBy: 0,
      entityType: GlobalStore.entityType,
      onKraFromCache: (data: any) => {
        applyKraResponseToStore(data, { setGender: true });
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onDigiLockerFromCache: (data: any) => {
        GlobalStore.isDigiLocker = true;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isDigiLocker = true;
        clientPartialDetails_ao.signzydt = "";
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        getProfileDetailsFromAadhar(data);
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onNormalClientFromCache: (data: any) => {
        GlobalStore.isNormalClient = true;
        GlobalStore.isKYC = false;
        GlobalStore.isKRA = false;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.addressLine1 =
          data.PermanentAddressDetails.PermanentAddressLine1;
        clientPartialDetails_ao.addressLine1 +=
          data.PermanentAddressDetails.PermanentAddressLine2;
        clientPartialDetails_ao.addressLine1 +=
          data.PermanentAddressDetails.PermanentAddressLine3;
        clientPartialDetails_ao.addressLine1 +=
          data.PermanentAddressDetails.PermanentAddressLine4;
        clientPartialDetails_ao.sameAsPermanent =
          data.corrsaddraspermanent !== null &&
            data.corrsaddraspermanent !== undefined
            ? data.corrsaddraspermanent
            : true;
        clientPartialDetails_ao.corrAddress =
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine1;
        clientPartialDetails_ao.corrAddress +=
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine2;
        clientPartialDetails_ao.corrAddress +=
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine3;
        clientPartialDetails_ao.corrAddress +=
          data.CorrespondenceAddressDetails.CorrespondenceAddressLine4;
        clientPartialDetails_ao.isSeniorCitizen =
          window.sessionStorage.getItem("isSeniorCitizen") === "true"
            ? true
            : false;
        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.dob = GlobalStore.dob;
        clientPartialDetails_ao.emailID = GlobalStore.user.email;
        clientPartialDetails_ao.PinCode =
          data.PermanentAddressDetails.PermanentPincode;
        clientPartialDetails_ao.corrPincode =
          data.CorrespondenceAddressDetails.CorrespondencePincode;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        clientPartialDetails_ao.leadID = GlobalStore.leadId;
        clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
        clientPartialDetails_ao.pan = GlobalStore?.personaldetails?.pan;
        clientPartialDetails_ao.panDetails =
          GlobalStore.personaldetails.panDetails;
        clientPartialDetails_ao.token = GlobalStore.token;
        clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onKraValid: () => {
        navigate(dashboardUrl.profile);
        setIsLoading(false);
      },
      onKraInvalid: () => {
        GlobalStore.isNormalClient = true;
        GlobalStore.isKYC = false;
        GlobalStore.isKRA = false;
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.isSeniorCitizen =
          window.sessionStorage.getItem("isSeniorCitizen") === "true"
            ? true
            : false;
        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.dob = GlobalStore.dob;
        clientPartialDetails_ao.emailID = GlobalStore.user.email;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        clientPartialDetails_ao.leadID = GlobalStore.leadId;
        clientPartialDetails_ao.mobile = GlobalStore.user.mobile;
        clientPartialDetails_ao.pan = GlobalStore?.personaldetails?.pan;
        clientPartialDetails_ao.panDetails =
          GlobalStore.personaldetails.panDetails;
        clientPartialDetails_ao.token = GlobalStore.token;
        clientPartialDetails_ao.isSeeding = GlobalStore.isSeeding;
        clientPartialDetails_ao.isKRA = GlobalStore.isKRA;
        clientPartialDetails_ao.isKYC = GlobalStore.isKYC;
        clientPartialDetails_ao.isNormalClient = GlobalStore.isNormalClient;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        if (clientPartialDetails_ao?.applicationId?.includes("I")) {
          navigate(dashboardUrl.personalIfo);
        } else {
          navigate(containerUrl.dgLocker);
        }
        setIsLoading(false);
      },
      onKraError: (res: any) => {
        setErrCode(res.error);
        setIsLoading(false);
      },
      onNoKraFallback: onNoCacheNoKraFallback,
    });
  };
  function getClientStageDetails(res: any) {
    // console.log("AGetStageCompletionStatus", res);
    setIsLoading(true);
    if (!res || res.error) {
      setErrCode(res.error);
    } else {
      // debugger
      if (res.data) {
        const responseObj = JSON.parse(res.data);
        GlobalStore.entityType = responseObj?.entitytype
        GlobalStore.entitySubType = responseObj?.entitysubtype
        GlobalStore.personaldetails.fsfullName = GlobalStore.personaldetails
          .fsfullName
          ? GlobalStore.personaldetails.fsfullName
          : responseObj?.fatherspousename;
        GlobalStore.isOTCFlow = responseObj?.isotc
        GlobalStore.isNriOtc = responseObj?.isNRI && responseObj?.isotc
        GlobalStore.isNriInv = responseObj?.isNRI

        //set stage api data to GlobalStore
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );

        console.log(clientPartialDetails_ao, "clientPartialDetails_ao");

        if (!clientPartialDetails_ao.mobile) {
          clientPartialDetails_ao.mobile = responseObj.mobileno;
        }

        if (!clientPartialDetails_ao.emailID) {
          clientPartialDetails_ao.emailID = responseObj.emailid;
        }
        if (
          responseObj?.fatherspousename != null &&
          responseObj?.fatherspousename != undefined &&
          responseObj?.fatherspousename !== ""
        ) {
          clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
        }
        if (responseObj?.dob !== null && responseObj?.dob !== undefined) {
          let date = moment(moment(convertDate(responseObj?.dob)).toDate())
            .startOf("day")
            .toDate();
          if (date !== null && date !== undefined && ageCalculator(date) > 60) {
            window.sessionStorage.setItem("isSeniorCitizen", "true");
          } else {
            window.sessionStorage.setItem("isSeniorCitizen", "false");
          }
        }
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        setStageData(responseObj);
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFound,
          addressRejctedFound
        );
        if (dematAccountFound !== null && dematAccountFound !== undefined) {
          markStepIncomplete(dashboardUrl?.demat);
          navigate(dashboardUrl?.demat)
          return;
        }
        if (addressRejctedFound !== null && addressRejctedFound !== undefined && responseObj.bpm_pd_status === 2 && !responseObj?.isotc) {
          markStepIncomplete(dashboardUrl?.personalIfo);
          navigate(dashboardUrl?.personalIfo)
          return;
        }
        //check completeness of stages

        //route according to stage api response -- delegated to the
        //centralized status-navigation ladder (navigationOrchestrator).
        let cacheKraTriggered = false;
        const navigationUrl = resolveStatusNavigationUrl(responseObj, {
          userId,
          isUploadDocumentsCompleted,
          onNeedsCacheAndKra: () => {
            cacheKraTriggered = true;
            resolveCacheAndKraForClient(() => {
              if (responseObj?.isaddressstagecompleted === false && !responseObj?.isotc) {
                navigate(dashboardUrl?.personalIfo)
              } else {
                navigate(dashboardUrl.profile)
              }
            }, responseObj?.dob);
          },
        });
        if (navigationUrl) {
          navigate(navigationUrl);
          return;
        }
        if (cacheKraTriggered) {
          return;
        }
      }
    }
    setIsLoading(false);
  }

  function getClientStageDetailsNew(
    res: any,
    isUploadDocumentsCompleted: boolean,
    reqObj?: any,
    dematAccountFoundLocaL?: any,
    handleNavigateForEsignFlow?: boolean
  ) {
    if (!res || res?.error) {
      // setErrCode('1061 - Error in fetching stage completion details.');
      // setErrCode(errorMessage.getClientStageDetails);
      setIsLoading(false);
    } else {
      if (res.data && res.data !== null) {
        const responseObj = JSON.parse(res.data);
        if (responseObj.compfirmname)
          window.sessionStorage.setItem("clientNameNew", responseObj.compfirmname)
        const clientPartialDetails_ao = JSON.parse(
          window.localStorage.getItem("clientPartialDetails_ao") || "{}"
        );
        setStageData(responseObj);
        //check completeness of stages
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
        );
        console.log(clientPartialDetails_ao, "clientPartialDetails_ao");

        if (!clientPartialDetails_ao.mobile) {
          clientPartialDetails_ao.mobile = responseObj.mobileno;
        }

        if (!clientPartialDetails_ao.emailID) {
          clientPartialDetails_ao.emailID = responseObj.emailid;
        }
        clientPartialDetails_ao.pan = GlobalStore.personaldetails.pan;

        clientPartialDetails_ao.clientPrimaryDetailId =
          GlobalStore.clientPrimaryDetailId;
        clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
        clientPartialDetails_ao.accountcategory = GlobalStore.accountcategory;
        clientPartialDetails_ao.token = GlobalStore.token;
        if (
          responseObj?.fatherspousename != null &&
          responseObj?.fatherspousename != undefined &&
          responseObj?.fatherspousename !== ""
        ) {
          clientPartialDetails_ao.fsfullName = responseObj?.fatherspousename;
        }
        clientPartialDetails_ao.dpid = responseObj?.dpid;
        clientPartialDetails_ao.clientid = responseObj?.dpclientid;
        GlobalStore.dpid = responseObj?.dpid;
        GlobalStore.clientid = responseObj?.dpclientid;
        GlobalStore.entityType = responseObj?.entitytype;
        GlobalStore.entitySubType = responseObj?.entitysubtype;
        window.localStorage.setItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        //set stage api data to GlobalStore
        setStageData(responseObj);
        let cacheData = null;
        //check completeness of stages
        checkModuleCompleteness(
          isUploadDocumentsCompleted,
          dematAccountFoundLocaL ? dematAccountFoundLocaL : dematAccountFound
        );

        if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined
        ) {
          if (
            !(
              responseObj.isprofiledetailscompleted &&
              responseObj.ispersonaldetailscompleted
            )
          ) {
          }
          GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        }

        if (responseObj.iskyc) GlobalStore.isKYC = true;

        if (
          !(
            responseObj.isprofiledetailscompleted &&
            responseObj.ispersonaldetailscompleted
          )
        ) {
          GlobalStore.nextIncompleteStage = dashboardUrl.profile;
        } else if (!responseObj.isbankdetailscompleted) {
          GlobalStore.nextIncompleteStage = dashboardUrl.bank;
        } else if (
          responseObj?.accountcategory === 2 &&
          !responseObj?.isdpcompleted
        )
          GlobalStore.nextIncompleteStage = dashboardUrl.demat;
        else if (!isUploadDocumentsCompleted && !handleNavigateForEsignFlow)
          GlobalStore.nextIncompleteStage = dashboardUrl.doc;
        else if (!isUploadDocumentsCompleted && handleNavigateForEsignFlow) {
          const sortedStages = [...GlobalStore.leftNavBarState].sort(
            (a, b) => a.priority - b.priority
          );
          const lastStageRoute = sortedStages[sortedStages.length - 1]?.navUrl;
          completeAllStagesExceptLast();
          GlobalStore.nextIncompleteStage = lastStageRoute;
        }
        else if (
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 0
        )
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress);
        else if (responseObj.bpm_pd_status === 1)
          // history.push(containerUrl.poa);
          navigate(containerUrl.poa);
        let newReqObj = reqObj;
        newReqObj.isKra = responseObj.iskra;
        if (!isUploadDocumentsCompleted && responseObj.bpm_pd_status === 2) {
          // history.push(statusUrl.documentReject);
          navigate(statusUrl.documentReject);
          return;
        }
        if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined &&
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 0
        ) {
          // history.push(statusUrl.docVerificationInProgress);
          navigate(statusUrl.docVerificationInProgress);
        } else if (
          reqObj?.skipUrlBoolean &&
          reqObj?.rmid !== null &&
          reqObj?.rmid !== undefined &&
          responseObj.applicationstatus === 1 &&
          responseObj.bpm_pd_status === 1
        ) {
          if (
            responseObj.isesigncompleted !== null &&
            responseObj.isesigncompleted == true &&
            responseObj?.auth_ver &&
            responseObj?.accountcategory === 2 &&
            responseObj?.elog_opted &&
            responseObj.isKra
          ) {
            // history.push(statusUrl.elogVerificationInProgress);
            navigate(statusUrl.elogVerificationInProgress);
          } else if (
            responseObj.isesigncompleted !== null &&
            responseObj.isesigncompleted == true &&
            responseObj?.auth_ver &&
            responseObj?.accountcategory === 2
          ) {
            // history.push(containerUrl.esignsubmit);
            navigate(containerUrl.esignsubmit);
          } else {
            if (
              responseObj.iskra !== null &&
              responseObj.iskra !== undefined &&
              responseObj?.auth_ver
            ) {
              // history.push(containerUrl.kycsubmit);
              navigate(containerUrl.kycsubmit);
              // } else history.push(containerUrl.kycsubmit);
            } else navigate(containerUrl.kycsubmit);
          }
        }
      } else {

      }
    }
  }

  function newAccountRedirect() {
    const rmLinkRaw: any = sessionStorage.getItem("rmInvestmentLink");
    let rmLink = JSON.parse(rmLinkRaw)
    if (rmLink) {
      // history.push(`${containerUrl.opclient
      // navigate(`${containerUrl)}${rmLink}`);
    } else {
      GlobalStore.isPartialFilledClient = true;
      clientPartialDetailsToStore({ applicationID: "" });
      localStorage?.removeItem("clientPartialDetails_ao");
      // history.replace(containerUrl.registration);
      navigate(containerUrl.registration, { replace: true })
    }
  }

  return (
    <div className="wb">
      <div className="wbLogo">
        <ProfileImage>
          <img src={welcomeBack} alt="" aria-hidden="true" className="pfImg" />
        </ProfileImage>
      </div>
      <h1 className="wbheading">
        Welcome Back {clientName}
      </h1>
      <div className="wbInfo">
        <p className="infoLine">
          We’ve detected a previous account opening in process. Would you like
          to continue or start afresh?
        </p>
      </div>
      {/* Error Msg Start*/}
      {errCode && (
        <div className="errMsgBlck">
          <ErrMsg>
            {typeof errCode === "number" ? (
              <>
                <span>We are facing some technical issue.</span>
                <span>Please try after sometime (error code:{errCode})</span>
              </>
            ) : (
              <span>{errCode}</span>
            )}
          </ErrMsg>
        </div>
      )}
      {/* Error Msg End*/}
      <div className="wbBtns">
        <div className="wbBtn">
          <Button
            btnName="New Account"
            disabled={isLoading}
            isSecondary={true}
            isLoading={isLoading}
            onClick={newAccountRedirect}
          />
        </div>
        <div className="wbBtn wbcntn">
          <Button
            btnName="Continue"
            disabled={isLoading}
            isLoading={isLoading}
            onClick={populateSavedData}
          />
        </div>
      </div>
    </div>
  );
};

export default WelcomeBack;
